// دائرة النطاق الجغرافي كـ GeoJSON (بالمتر) لعرضها على الخريطة.
const EARTH_KM = 6371;

export const circleGeoJson = (lat, lng, radiusM, steps = 64) => {
  const distanceX = radiusM / 1000 / (111.32 * Math.cos((lat * Math.PI) / 180));
  const distanceY = radiusM / 1000 / 110.574;
  const ring = [];
  for (let i = 0; i < steps; i += 1) {
    const theta = (i / steps) * (2 * Math.PI);
    ring.push([lng + distanceX * Math.cos(theta), lat + distanceY * Math.sin(theta)]);
  }
  ring.push(ring[0]);
  return { type: "Feature", geometry: { type: "Polygon", coordinates: [ring] } };
};

// المسافة بين نقطتين بالمتر (Haversine) — للاستخدام في مؤشرات القرب.
export const distanceMeters = (aLat, aLng, bLat, bLng) => {
  const toRad = (v) => (v * Math.PI) / 180;
  const dLat = toRad(bLat - aLat);
  const dLng = toRad(bLng - aLng);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(aLat)) * Math.cos(toRad(bLat)) * Math.sin(dLng / 2) ** 2;
  return Math.round(2 * EARTH_KM * 1000 * Math.asin(Math.sqrt(h)));
};
